import React from 'react';
import makeStyles from '@material-ui/styles/makeStyles';
import { Check } from '@material-ui/icons';

const useStyles = makeStyles({
    root: {
        display: 'flex',
        alignItems: 'center',
        margin: '18px 0',
    },
    text: {
        marginLeft: '18px',
        fontWeight: 400,
        fontSize: '1.1rem',
        color: '#212121',
        '&.current': {
            fontWeight: 600,
        },
        '&.incomplete': {
            color: '#8D98B7',
        },
    },
    icon: {
        height: '1.4rem',
        width: '1.4rem',
        lineHeight: '1.4rem',
        borderRadius: '1.4rem',
        fontSize: '0.85rem',
        fontWeight: 600,
        textAlign: 'center',
        backgroundColor: 'transparent',
        '&.current': {
            backgroundColor: '#FFDD02',
        },
        '&.incomplete': {
            backgroundColor: '#E8EAF4',
        },
    },
});

export interface IStageChecklistItem {
    displayName: string;
    state: 'current' | 'done' | 'incomplete';
    index: number;
}

const StageChecklistItem = (props: IStageChecklistItem) => {
    const classes = useStyles();
    return (
        <div className={classes.root}>
            <span className={`${classes.icon} ${props.state}`}>
                {props.state === 'current' ? (
                    props.index + 1
                ) : props.state === 'done' ? (
                    <Check htmlColor="#FFDD02" />
                ) : (
                    ''
                )}
            </span>
            <span className={`${classes.text} ${props.state}`}>{props.displayName}</span>
        </div>
    );
};

export default StageChecklistItem;
